import moment from "moment";

export const amortizationCalcultion = (liability, moduleName) => {
  if (!liability) {
    console.error("Missing required data.");
    return;
  }
  let keys = [
    "Month",
    "One-time Funding",
    "Snowball",
    liability["Nickname of Liabilities"],
    "End Balance",
  ];

  let temp = {};
  temp["header"] = keys;

  let nickname = "";
  if (
    moduleName === "Credit Card - Business" ||
    moduleName === "Credit Card - Personal" ||
    moduleName === "Credit - HELOC"
  ) {
    nickname = liability["Nickname of Credit"]
      ? liability["Nickname of Credit"]
      : "N/A";
  } else {
    nickname = liability["Nickname of Liabilities"]
      ? liability["Nickname of Liabilities"]
      : "N/A";
  }

  let initialLoanAmount = 0;
  if (
    moduleName === "Credit Card - Business" ||
    moduleName === "Credit Card - Personal" ||
    moduleName === "Credit - HELOC"
  ) {
    initialLoanAmount = liability["Credit Balance"] || 0;
  } else {
    initialLoanAmount = liability["Initial Loan Amount"] || 0;
  }
  initialLoanAmount =
    typeof initialLoanAmount === "string"
      ? parseFloat(initialLoanAmount.replace(/[$,]/g, "").trim()) || 0
      : initialLoanAmount;

  let interestRate = 0;
  if (
    moduleName === "Credit Card - Business" ||
    moduleName === "Credit Card - Personal" ||
    moduleName === "Credit - HELOC"
  ) {
    interestRate = +liability["Interest Rate (or APR%)"] || 0;
  } else {
    interestRate = +liability["Interest Rate"] || 0;
  }

  interestRate =
    typeof interestRate === "string"
      ? parseFloat(interestRate.replace(/[$,]/g, "").trim()) / 100 || 0
      : interestRate / 100;
  let startDate = liability["Start Date"]
    ? new Date(liability["Start Date"])
    : new Date();
  let maturityDate = liability["Maturity Date"]
    ? new Date(liability["Maturity Date"])
    : new Date();
  let monthlyPayment = 0;
  if (
    moduleName === "Credit Card - Business" ||
    moduleName === "Credit Card - Personal" ||
    moduleName === "Credit - HELOC"
  ) {
    monthlyPayment = liability["Monthly Payment"]
      ? typeof liability["Monthly Payment"] === "string"
        ? parseFloat(liability["Monthly Payment"].replace(/[$,]/g, "").trim())
        : liability["Monthly Payment"] // If it's already a number, use it directly
      : 0;
  } else {
    monthlyPayment = liability["Monthly Payment"]
      ? typeof liability["Monthly Payment"] === "string"
        ? parseFloat(liability["Monthly Payment"].replace(/[$,]/g, "").trim())
        : liability["Monthly Payment"] // If it's already a number, use it directly
      : 0;
    // calculatePMT(
    //     initialLoanAmount,
    //     interestRate,
    //     startDate,
    //     maturityDate,
    //   );
  }
  monthlyPayment =
    typeof monthlyPayment === "string"
      ? parseFloat(monthlyPayment.replace(/[$,]/g, "").trim()) || 0
      : monthlyPayment;

  let data = {
    total: 0,
    data: [],
    ILA: initialLoanAmount,
    InterestRate: interestRate,
    minimum: monthlyPayment,
    startDate: startDate,
    active: true,
  };

  let endBalance = initialLoanAmount;
  let newEndBal = endBalance;
  let iterationCount = 0;
  const maxIterations = 2000;
  let otpData = {};

  // oneTimeFunding && oneTimeFunding.forEach(
  //   val => (otpData[moment(val.date).format('MM-DD-YYYY')] = val.payment)
  // );

  let formattedLiabilityData = [];
  let cumulativeInterest = 0;
  let cumulativePrincipal = 0;
  // Iterate for a single liability
  while (data.ILA > 0 && iterationCount < maxIterations) {
    let startDate = data.startDate;
    let obj = { date: moment(startDate).format("MM-DD-YYYY") };
    startDate.setMonth(startDate.getMonth() + 1); // Default to monthly

    let oneTimeMonthFunding = 0;
    let weekDate = new Date(obj.date);
    let weekMonth = weekDate.getMonth();
    let weekYear = weekDate.getFullYear();

    for (let dateStr in otpData) {
      let otpDate = new Date(dateStr);
      let otpMonth = otpDate.getMonth();
      let otpYear = otpDate.getFullYear();
      if (weekMonth === otpMonth && weekYear === otpYear) {
        oneTimeMonthFunding = otpData[dateStr];
        break;
      }
    }

    let snowballAmount = monthlyPayment + oneTimeMonthFunding;
    let monthlyInterestRate = data.InterestRate / 12;
    let interestRatePaid = data.ILA * monthlyInterestRate;
    let principal = data.minimum;

    obj[nickname] = Math.round((interestRatePaid + principal) * 100) / 100;
    obj.interestRatePaid = parseFloat(interestRatePaid).toFixed(2);
    obj.principal = parseFloat(principal).toFixed(2);
    obj.remaining = parseFloat(data.ILA).toFixed(2);
    obj.principalPaid = parseFloat(principal - interestRatePaid).toFixed(2);
    data.total += Math.round(interestRatePaid * 100) / 100;
    data.ILA -= parseFloat(principal - interestRatePaid).toFixed(2);

    cumulativeInterest += parseFloat(interestRatePaid);
    cumulativePrincipal += parseFloat(obj.principalPaid);

    if (obj.remaining > 0) {
      formattedLiabilityData.push({
        date: obj.date,
        // valuepayable: obj[nickname],
        interestRate: +interestRate * 100,
        monthlyPayment: +obj.principal,
        interestRatePaid: +obj.interestRatePaid,
        principalPaid: +obj.principalPaid,
        balance: +obj.remaining,
        cumulativeInterest: cumulativeInterest,
        cumulativePrincipal: cumulativePrincipal,
      });
    }

    iterationCount++;
  }

  if (iterationCount >= maxIterations) {
    console.log("Exceeded maximum iteration limit. Terminating loop.");
    return;
  }

  const currentMonth = moment().format("MM-YYYY");

  const currentMonthRow =
    formattedLiabilityData &&
    formattedLiabilityData.find(
      (row) => moment(row.date, "MM-DD-YYYY").format("MM-YYYY") === currentMonth
    );

  console.log("Current Month Row:", currentMonthRow);
  return currentMonthRow;
};

export const calculateAmortization = (id, liability, moduleName) => {
  if (!liability) {
    console.error("Missing required data.");
    return;
  }

  let keys = [
    "Month",
    "One-time Funding",
    "Snowball",
    liability["Nickname of Liabilities"],
    "End Balance",
  ];

  let temp = {};
  temp["header"] = keys;

  let nickname = "";
  if (
    moduleName === "Credit Card - Business" ||
    moduleName === "Credit Card - Personal" ||
    moduleName === "Credit - HELOC"
  ) {
    nickname = liability["Nickname of Credit"]
      ? liability["Nickname of Credit"]
      : "N/A";
  } else {
    nickname = liability["Nickname of Liabilities"]
      ? liability["Nickname of Liabilities"]
      : "N/A";
  }

  let initialLoanAmount = 0;
  if (
    moduleName === "Credit Card - Business" ||
    moduleName === "Credit Card - Personal" ||
    moduleName === "Credit - HELOC"
  ) {
    initialLoanAmount = liability["Credit Balance"] || 0;
  } else {
    initialLoanAmount = liability["Initial Loan Amount"] || 0;
  }
  initialLoanAmount =
    typeof initialLoanAmount === "string"
      ? parseFloat(initialLoanAmount.replace(/[$,]/g, "").trim()) || 0
      : initialLoanAmount;

  let interestRate = 0;
  if (
    moduleName === "Credit Card - Business" ||
    moduleName === "Credit Card - Personal" ||
    moduleName === "Credit - HELOC"
  ) {
    interestRate = +liability["Interest Rate (or APR%)"] || 0;
  } else {
    interestRate = +liability["Interest Rate"] || 0;
  }

  interestRate =
    typeof interestRate === "string"
      ? parseFloat(interestRate.replace(/[$,]/g, "").trim()) / 100 || 0
      : interestRate / 100;
  let startDate = liability["Start Date"]
    ? new Date(liability["Start Date"])
    : new Date();
  let maturityDate = liability["Maturity Date"]
    ? new Date(liability["Maturity Date"])
    : new Date();
  let monthlyPayment = 0;
  let monthlyPaymentLiability = calculateMonthlyPayment(liability);
  if (
    moduleName === "Credit Card - Business" ||
    moduleName === "Credit Card - Personal" ||
    moduleName === "Credit - HELOC"
  ) {
    monthlyPayment = liability["Monthly Payment"]
      ? typeof liability["Monthly Payment"] === "string"
        ? parseFloat(liability["Monthly Payment"].replace(/[$,]/g, "").trim())
        : liability["Monthly Payment"] // If it's already a number, use it directly
      : 0;
  } else {
    monthlyPayment = liability["Monthly Payment"]
      ? typeof liability["Monthly Payment"] === "string"
        ? parseFloat(
            liability["Monthly Payment"].replace(/[$,]/g, "").trim()
          ) || monthlyPaymentLiability
        : liability["Monthly Payment"]
      : monthlyPaymentLiability;
    // calculatePMT(
    //     initialLoanAmount,
    //     interestRate,
    //     startDate,
    //     maturityDate,
    //   );
  }
  monthlyPayment =
    typeof monthlyPayment === "string"
      ? parseFloat(monthlyPayment.replace(/[$,]/g, "").trim()) || 0
      : monthlyPayment;

  let data = {
    total: 0,
    data: [],
    ILA: initialLoanAmount,
    InterestRate: interestRate,
    minimum: monthlyPayment,
    startDate: startDate,
    active: true,
  };

  let endBalance = initialLoanAmount;
  let newEndBal = endBalance;
  let iterationCount = 0;
  const maxIterations = 2000;
  let otpData = {};

  // oneTimeFunding && oneTimeFunding.forEach(
  //   val => (otpData[moment(val.date).format('MM-DD-YYYY')] = val.payment)
  // );

  let formattedLiabilityData = [];
  let cumulativeInterest = 0;
  let cumulativePrincipal = 0;
  // Iterate for a single liability
  while (data.ILA > 0 && iterationCount < maxIterations) {
    let startDate = data.startDate;
    let obj = { date: moment(startDate).format("MM-DD-YYYY") };
    startDate.setMonth(startDate.getMonth() + 1); // Default to monthly

    let oneTimeMonthFunding = 0;
    let weekDate = new Date(obj.date);
    let weekMonth = weekDate.getMonth();
    let weekYear = weekDate.getFullYear();

    for (let dateStr in otpData) {
      let otpDate = new Date(dateStr);
      let otpMonth = otpDate.getMonth();
      let otpYear = otpDate.getFullYear();
      if (weekMonth === otpMonth && weekYear === otpYear) {
        oneTimeMonthFunding = otpData[dateStr];
        break;
      }
    }

    let snowballAmount = monthlyPayment + oneTimeMonthFunding;
    let monthlyInterestRate = data.InterestRate / 12;
    let interestRatePaid = data.ILA * monthlyInterestRate;
    // let principal = data.minimum;
    let principal = data.ILA + interestRatePaid < data.minimum
      ? data.ILA + interestRatePaid
      : data.minimum;

    obj[nickname] = Math.round((interestRatePaid + principal) * 100) / 100;
    obj.interestRatePaid = parseFloat(interestRatePaid).toFixed(2);
    obj.principal = parseFloat(principal).toFixed(2);
    data.ILA -= parseFloat(principal - interestRatePaid).toFixed(2);
    obj.remaining = parseFloat(data.ILA).toFixed(2);
    obj.principalPaid = parseFloat(principal - interestRatePaid).toFixed(2);
    data.total += Math.round(interestRatePaid * 100) / 100;

    cumulativeInterest += parseFloat(interestRatePaid);
    cumulativePrincipal += parseFloat(obj.principalPaid);

    // if (obj.remaining > 0) {
      formattedLiabilityData.push({
        date: obj.date,
        // valuepayable: obj[nickname],
        interestRate: +interestRate * 100,
        monthlyPayment: +obj.principal,
        interestRatePaid: +obj.interestRatePaid,
        principalPaid: +obj.principalPaid,
        balance: (Math.max(0, +obj.remaining)).toFixed(2),
        cumulativeInterest: cumulativeInterest,
        cumulativePrincipal: cumulativePrincipal,
      });
    // }
    if (obj.remaining <= 0) break;
    iterationCount++;
  }

  console.log(
    "Formatted Liability Data:",
    formattedLiabilityData,
    liability,
    moduleName
  );

  // if (iterationCount >= maxIterations) {
  //   console.log("Exceeded maximum iteration limit. Terminating loop.");
  //   return;
  // }
  console.log("Formatted Amortization Data----------", formattedLiabilityData);
  return { formattedLiabilityData, monthlyPayment };
  // await handleSubmitAmortization(id, formattedLiabilityData);
};

export const calculateMonthlyPayment = (payload) => {
  console.log("payload monthly", payload);

  let Interest = payload["Interest Rate"] || 0;
  let loanAmount = payload["Initial Loan Amount"] || 0;
  let Start = payload["Start Date"] || new Date();
  let Maturity = payload["Maturity Date"] || new Date();

  let StartDate1 = new Date(Start);
  let MaturityDate1 = new Date(Maturity);

  let numberOfPayments = 0;

  if (StartDate1 && MaturityDate1) {
    // Calculate the difference in months
    numberOfPayments =
      (MaturityDate1.getFullYear() - StartDate1.getFullYear()) * 12;
    numberOfPayments -= StartDate1.getMonth();
    numberOfPayments += MaturityDate1.getMonth();

    // Check if there's a partial month based on days
    if (MaturityDate1.getDate() >= StartDate1.getDate()) {
      numberOfPayments += 1;
    }
  }

  console.log("numberOfPayments", numberOfPayments);

  let rate = Interest / 100 / 12;
  let monthlyRate = Interest / 100 / 12;
  // Using the formula to calculate the monthly payment
  let MonthlyPayment =
    (loanAmount * monthlyRate) /
    (1 - Math.pow(1 + monthlyRate, -numberOfPayments));
  // loanAmount * rate / (1 - Math.pow(1 + rate, -numberOfPayments));
  MonthlyPayment =
    isNaN(MonthlyPayment) || !isFinite(MonthlyPayment)
      ? 0
      : MonthlyPayment.toFixed(2);

  return MonthlyPayment;
};

export const generateAmortizationData = ({
  liabilitiesData,
  snowball = 0,
  oneTimeFundingDataUnpaid = [],
  returnCreditEndDates = false,
  onlyReturnCreditEndDates = false,
  returnNewDebtAndIntrest = false,
  selectedPriority = "Highest Interest First",
}) => {
  let result = { header: [], data: [] };
  let tableRows = [];
  const getValidBalance = (item) => {
    return parseFloat(item["Loan Balance"]) > 0
      ? parseFloat(item["Loan Balance"])
      : parseFloat(item["Initial Loan Amount"]) || 0;
  };
  console.log("onetimeeee", oneTimeFundingDataUnpaid);
  // Sort liabilities based on priority
  const sortedLiabilitiesData =
    liabilitiesData &&
    [...liabilitiesData].sort((a, b) => {
      if (selectedPriority === "Highest Interest First") {
        const aRate = a["Interest Rate"] || a["Interest Rate (or APR%)"] || 0;
        const bRate = b["Interest Rate"] || b["Interest Rate (or APR%)"] || 0;
        return bRate - aRate;
      } else {
        // Lowest Balance First
        return getValidBalance(a) - getValidBalance(b);
      }
    });
  const liabilityNames = sortedLiabilitiesData && [
    ...new Set(
      sortedLiabilitiesData
        .map((item) => item["Nickname of Liabilities"])
        .filter(Boolean)
    ),
  ];

  let headers = [
    "Month",
    "Snowball",
    "One-time Funding",
    ...(liabilityNames || []),
    "End Balance",
  ];
  result.header = headers;

  let liabilityKeys =
    sortedLiabilitiesData &&
    sortedLiabilitiesData.map((item) => item["Nickname of Liabilities"]);
  const liabilities = {};
  sortedLiabilitiesData &&
    sortedLiabilitiesData.forEach((item) => {
      const nickname = item["Nickname of Liabilities"];
      liabilities[nickname] = {
        totalInterestPaid: 0,
        paymentHistory: [],
        remainingBalance: getValidBalance(item),
        interestRate: item["Interest Rate"]
          ? item["Interest Rate"] / 100 || 0
          : item["Interest Rate (or APR%)"]
          ? item["Interest Rate (or APR%)"] / 100
          : 0,
        minimumPayment: item["Monthly Payment"]
          ? parseFloat(item["Monthly Payment"])
          : 0,
        isActive: true,
      };
    });

  let totalMonthlyPayment =
    snowball +
    (sortedLiabilitiesData &&
      sortedLiabilitiesData.reduce(
        (sum, item) => sum + parseFloat(item["Monthly Payment"] || 0),
        0
      ));

  let totalOutstandingBalance =
    sortedLiabilitiesData &&
    sortedLiabilitiesData.reduce((sum, item) => sum + getValidBalance(item), 0);
  let iteration = 0;
  let totalPrincipalPaid = 0;
  let currentDate = new Date();
  let amortizationRows = [];
  let updatedOutstandingBalance = totalOutstandingBalance;
  let oneTimePaymentsMap = {};
  let debtPayoffDates = [];

  oneTimeFundingDataUnpaid &&
    oneTimeFundingDataUnpaid.forEach((payment) => {
      const monthKey = moment(payment.date).format("MMM-YY");
      oneTimePaymentsMap[monthKey] = payment.payment;
    });
  console.log("oneTimePaymentsMap", oneTimePaymentsMap);

  let maxIterations = 2000;
  let cumulativeInterestPaid = 0;

  while (
    liabilityKeys &&
    liabilityKeys.length > 0 &&
    iteration < maxIterations
  ) {
    iteration++;
    let currentMonthData = { month: moment(currentDate).format("MMM-YY") };

    let oneTimePayment = oneTimePaymentsMap[currentMonthData.month] || 0;
    let totalAvailableFunds = totalMonthlyPayment + oneTimePayment;

    let snowballAvailable =
      totalAvailableFunds -
      Object.values(liabilities).reduce(
        (sum, liability) =>
          sum + (liability.isActive ? liability.minimumPayment : 0),
        0
      );

    let dynamicSnowball = snowballAvailable;
    let principalPaidThisMonth = 0;

    liabilityKeys &&
      liabilityKeys.forEach((nickname) => {
        let liability = liabilities[nickname];
        let monthlyInterest =
          liability.remainingBalance * (liability.interestRate / 12);
        let principal;

        if (
          liability.remainingBalance <=
          liability.minimumPayment + dynamicSnowball
        ) {
          debtPayoffDates.push({
            nickname: nickname,
            endingMonth: moment(currentDate).format("MM-DD-YYYY"),
          });

          liability.isActive = false;
          principal = liability.remainingBalance;
          let totalPaid = Math.round((monthlyInterest + principal) * 100) / 100;

          if (
            !liability.isActive ||
            liability.remainingBalance <= 0 ||
            totalPaid < 0.01
          ) {
            totalPaid = 0;
          }

          currentMonthData[nickname] = totalPaid;
          snowballAvailable =
            Math.round(
              (liability.minimumPayment + snowballAvailable - totalPaid) * 100
            ) / 100;
          dynamicSnowball = snowballAvailable;
        } else {
          principal =
            liability.minimumPayment + (dynamicSnowball || 0) - monthlyInterest;
          if (dynamicSnowball > 0) dynamicSnowball = 0;
        }

        currentMonthData[nickname] =
          Math.round((monthlyInterest + principal) * 100) / 100;
        liability.totalInterestPaid += Math.round(monthlyInterest * 100) / 100;
        liability.remainingBalance -= Math.round(principal * 100) / 100;

        liability.paymentHistory.push({
          month: new Date(
            currentDate.getTime() + iteration * 30 * 24 * 60 * 60 * 1000
          ),
          totalPaid: Math.round((monthlyInterest + principal) * 100) / 100,
          snowball: snowballAvailable,
          endBalance:
            Math.round(
              (totalOutstandingBalance -
                totalPrincipalPaid -
                snowballAvailable) *
                100
            ) / 100,
        });

        liabilities[nickname] = {
          ...liability,
          paymentHistory: [...liability.paymentHistory],
        };

        principalPaidThisMonth += Math.round(principal * 100) / 100;
        cumulativeInterestPaid += Math.round(monthlyInterest * 100) / 100;
      });

    Object.keys(liabilities).forEach((name) => {
      currentMonthData[name] =
        (!currentMonthData[name] && "") || currentMonthData[name];
    });

    totalPrincipalPaid += principalPaidThisMonth;
    currentMonthData.endBalance =
      Math.round(updatedOutstandingBalance * 100) / 100 - snowballAvailable;
    currentMonthData.snowball = snowballAvailable
      ? Math.round(snowballAvailable * 100) / 100
      : 0;

    updatedOutstandingBalance -= principalPaidThisMonth;
    amortizationRows.push({ ...currentMonthData });

    liabilityKeys =
      liabilityKeys &&
      liabilityKeys.filter((nickname) => liabilities[nickname].isActive);

    currentDate.setMonth(currentDate.getMonth() + 1);
  }

  if (iteration >= maxIterations) {
    console.error("Exceeded maximum iteration limit. Terminating loop.");
    return result;
  }

  amortizationRows = amortizationRows.map((row) => ({
    ...row,
    oneTimeFundingData: oneTimePaymentsMap[row.month] || "",
  }));

  amortizationRows.forEach((row) => {
    let rowData = {};
    liabilities &&
      Object.keys(liabilities).forEach((name) => (rowData[name] = row[name]));
    let formattedRow = {
      month: row.month,
      snowball: row.snowball,
      oneTimeFundingData: row.oneTimeFundingData,
      ...rowData,
      endBalance: row.endBalance,
    };

    tableRows.push(
      Object.values(formattedRow).map((value) => {
        if (typeof value === "number") {
          if (isNaN(value) || value < 0) return "0";
          return value.toLocaleString("en-US");
        }
        return value;
      })
    );
  });

  result.data = tableRows;

  let calculatedDebtIntrest =
    cumulativeInterestPaid && Number(cumulativeInterestPaid.toFixed(2));
  let calculatedDebtFree =
    result.data &&
    result.data[result.data.length - 1] &&
    result.data[result.data.length - 1][0] !== "Invalid date"
      ? moment(result.data[result.data.length - 1][0], "MMM-YY").format(
          "MMMM, YYYY"
        )
      : null;

  if (onlyReturnCreditEndDates) return debtPayoffDates;

  if (returnCreditEndDates) {
    return {
      amortizationTable: result,
      creditEndDates: debtPayoffDates,
    };
  }

  if (returnNewDebtAndIntrest) {
    return {
      newDebtFree: calculatedDebtFree,
      newDebtIntrest: calculatedDebtIntrest,
    };
  }
  let matched = null;
  if (Array.isArray(debtPayoffDates) && debtPayoffDates.length > 0) {
    matched = debtPayoffDates.reduce((earliest, current) => {
      const earliestDate = moment(earliest.endingMonth, "MM-DD-YYYY");
      const currentDate = moment(current.endingMonth, "MM-DD-YYYY");
      return currentDate.isBefore(earliestDate) ? current : earliest;
    }, debtPayoffDates[0]);
  }

  // Create modulewiseAmortizationData array
  const modulewiseAmortizationData =
    sortedLiabilitiesData &&
    sortedLiabilitiesData.map((liability) => {
      const nickname = liability["Nickname of Liabilities"];
      const interestRate =
        liability["Interest Rate"] || liability["Interest Rate (or APR%)"] || 0;
      const monthlyRate = interestRate / 100 / 12;
      let balance =
        parseFloat(liability["Loan Balance"]) ||
        parseFloat(liability["Initial Loan Amount"]) ||
        0;
      const minimumPayment = parseFloat(liability["Monthly Payment"]) || 0;

      let cumulativeInterest = 0;
      let cumulativePrincipal = 0;
      let amortizationArray = [];
      let iterationCount = 0;
      let maxIterations = 2000;
      let startDate = new Date(liability["Start Date"] || new Date());

      while (balance > 0 && iterationCount < maxIterations) {
        let monthDate = moment(startDate).format("MM-DD-YYYY");
        startDate.setMonth(startDate.getMonth() + 1);

        let interestPaid = balance * monthlyRate;
        let principalPaid = Math.min(minimumPayment - interestPaid, balance);
        let totalPayment = principalPaid + interestPaid;

        cumulativeInterest += interestPaid;
        cumulativePrincipal += principalPaid;
        balance -= principalPaid;

        amortizationArray.push({
          month: monthDate,
          monthlyPayment: totalPayment.toFixed(2),
          interestPayment: interestPaid.toFixed(2),
          principalPaid: principalPaid.toFixed(2),
          remainingBalance: balance.toFixed(2),
          cumulativeInterest: cumulativeInterest.toFixed(2),
          cumulativePrincipal: cumulativePrincipal.toFixed(2),
        });

        iterationCount++;
      }

      const durationString =
        amortizationArray.length > 0
          ? moment(
              amortizationArray[amortizationArray.length - 1].month
            ).fromNow(true)
          : "in 0 years 0 months 0 days";

      return {
        item: liability,
        durationString,
        amortizationArray,
        principalPaidSum: cumulativePrincipal && cumulativePrincipal.toFixed(2),
        remainingBalance: balance && balance.toFixed(2),
        totalPaid: (cumulativePrincipal + cumulativeInterest).toFixed(2),
      };
    });
  const moduleAmortizationData =
    sortedLiabilitiesData &&
    sortedLiabilitiesData.map((liability) => {
      const data = calculateAmortization(
        liability.id,
        liability,
        liability.module
      );
      return {
        ...data,
        nickname: liability["Nickname of Liabilities"] || "N/A", // ✅ Add nickname here safely
      };
    });

  return {
    amortizationTable: result,
    creditEndDates: debtPayoffDates,
    newDebtFree: calculatedDebtFree,
    newDebtIntrest: calculatedDebtIntrest,
    nextDebtFree: matched || null,
    modulewiseAmortizationData,
    moduleAmortizationData,
  };
};

export const calculateDebtPayoff = (
  debts,
  extraPayment = 0,
  oneTimePayments = {},
  strategy = "highestInterest"
) => {
  // Sort debts based on strategy
  const sortedDebts = [...debts].sort((a, b) => {
    if (strategy === "highestInterest") {
      return b.interestRate - a.interestRate;
    }
    return a.initialBalance - b.initialBalance;
  });

  let currentDate = new Date(
    Math.min(...debts.map((d) => d.startDate.getTime()))
  );

  let remainingDebts = sortedDebts.map((d) => ({
    ...d,
    balance: d.initialBalance,
  }));

  let totalInterestPaid = 0;
  let monthlyPayments = [];
  const maxIterations = 2000;
  let iteration = 0;
  const individualDebtPayoffDates = {};

  while (remainingDebts.length > 0 && iteration < maxIterations) {
    iteration++;
    currentDate.setMonth(currentDate.getMonth() + 1);
    const monthKey = moment(currentDate).format("MMM-YY");

    // Calculate available funds for this month
    const oneTimePayment = oneTimePayments[monthKey] || 0;
    const totalAvailable = extraPayment + oneTimePayment;

    // Process each debt
    remainingDebts = remainingDebts.map((debt) => {
      if (debt.balance <= 0) return debt;

      const monthlyInterest = (debt.balance * debt.interestRate) / 12;
      const availablePayment =
        debt.monthlyPayment + totalAvailable / remainingDebts.length;
      const principalPayment = Math.min(
        availablePayment - monthlyInterest,
        debt.balance
      );

      totalInterestPaid += monthlyInterest;
      debt.balance -= principalPayment;

      monthlyPayments.push({
        date: moment(currentDate).format("MM-DD-YYYY"),
        interestPaid: monthlyInterest,
        principalPaid: principalPayment,
        remainingBalance: debt.balance,
        debtNickname: debt.nickname,
      });

      // Track when each debt is paid off
      if (debt.balance <= 0 && !individualDebtPayoffDates[debt.nickname]) {
        individualDebtPayoffDates[debt.nickname] =
          moment(currentDate).format("MM-DD-YYYY");
      }

      return debt;
    });

    // Remove paid off debts
    remainingDebts = remainingDebts.filter((d) => d.balance > 0);
  }

  // Find the earliest debt-free date based on strategy
  let debtFreeDate = "";
  const originalDebtFreeDate = monthlyPayments.length
    ? monthlyPayments[monthlyPayments.length - 1].date
    : moment(currentDate).format("MM-DD-YYYY");

  if (strategy === "lowestBalance") {
    // For lowest balance strategy, find the earliest payoff date
    debtFreeDate =
      Object.values(individualDebtPayoffDates).sort()[0] ||
      originalDebtFreeDate;
  } else {
    // For highest interest strategy, use the last payment date
    debtFreeDate = originalDebtFreeDate;
  }

  return {
    totalInterestPaid,
    debtFreeDate,
    originalDebtFreeDate,
    monthlyPayments,
    individualDebtPayoffDates,
  };
};
